import Field from 'types/Field';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const asField = (o: Exclude<any, undefined | null>): Field => {
  return {
    ...o,
    default_value: o.default_value || [],
    preview_default_value: o.default_value || [],
    // preview_default_value: [],
  };
};

export { asField };
